/**
 * Snipetell Theme JS – Mobile menu + Hero slideshow
 */
document.addEventListener('DOMContentLoaded', () => {

  // ===== Dark / Light theme toggle =====
  // Default: light. Only switch if user chose before (localStorage) or clicks toggle.
  (function initThemeToggle() {
    const root = document.documentElement;
    const btn = document.querySelector('[data-theme-toggle]');
    const STORAGE_KEY = 'snipetell_user_theme';

    function getTheme() {
      return root.getAttribute('data-theme') || 'light';
    }

    function applyTheme(theme, persist) {
      var t = theme === 'dark' ? 'dark' : 'light';
      root.setAttribute('data-theme', t);
      try { root.style.colorScheme = t; } catch (e) {}
      if (persist) {
        try { localStorage.setItem(STORAGE_KEY, t); } catch (e) {}
      }
      if (btn) {
        btn.setAttribute('aria-label', t === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
        btn.setAttribute('title', t === 'dark' ? 'Light mode' : 'Dark mode');
      }
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) {
        meta.setAttribute('content', t === 'dark' ? '#14141c' : '#6D28D9');
      }
    }

    // Init: stored choice or force light (ignore OS dark preference)
    try {
      try { localStorage.removeItem('snipetell_theme'); } catch (e0) {}
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'dark' || stored === 'light') {
        applyTheme(stored, false);
      } else {
        applyTheme('light', false);
      }
    } catch (e) {
      applyTheme('light', false);
    }

    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        // User action → save to localStorage (cache)
        applyTheme(getTheme() === 'dark' ? 'light' : 'dark', true);
      });
    }
  })();

  // ===== Page load screen (first site open in this tab/session only) =====
  (function initPageLoader() {
    const loader = document.querySelector('[data-page-loader]');
    if (!loader) return;

    const hide = () => {
      loader.classList.add('is-done');
      loader.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem('snipetell_splash_seen', '1'); } catch (e) {}
      setTimeout(() => {
        if (loader.parentNode) loader.parentNode.removeChild(loader);
      }, 500);
    };

    let already = false;
    try { already = sessionStorage.getItem('snipetell_splash_seen') === '1'; } catch (e) {}

    if (already) {
      loader.classList.add('is-done');
      loader.setAttribute('aria-hidden', 'true');
      if (loader.parentNode) loader.parentNode.removeChild(loader);
      return;
    }

    if (document.readyState === 'complete') {
      setTimeout(hide, 450);
    } else {
      window.addEventListener('load', () => setTimeout(hide, 450));
      setTimeout(hide, 4000);
    }
  })();
  // ===== Logo typewriter: type → erase → bounce → erase → loop =====
  const typeEl = document.querySelector('[data-typewriter]');
  if (typeEl) {
    const textTarget = typeEl.querySelector('.logo-typewriter__text');
    const fullText = typeEl.dataset.text || 'Snipetell';
    // Reserve exact width so search bar never shifts
    typeEl.style.width = fullText.length + 1 + 'ch';
    typeEl.style.minWidth = typeEl.style.width;
    typeEl.style.maxWidth = typeEl.style.width;
    // 1.5x slower than previous timings
    const typeSpeed = 180;
    const eraseSpeed = 105;
    const holdTyped = 1800;
    const holdErased = 600;
    const holdBounce = 3300;

    let i = 0;
    // type | holdTyped | erase | holdErased | bounce | holdBounce | eraseAfterBounce
    let mode = 'type';

    function tick() {
      if (!textTarget) return;

      if (mode === 'type') {
        i += 1;
        textTarget.textContent = fullText.slice(0, i);
        typeEl.classList.remove('is-bounce');
        if (i >= fullText.length) {
          mode = 'holdTyped';
          setTimeout(tick, holdTyped);
        } else {
          setTimeout(tick, typeSpeed);
        }
        return;
      }

      if (mode === 'holdTyped') {
        mode = 'erase';
        setTimeout(tick, 0);
        return;
      }

      if (mode === 'erase' || mode === 'eraseAfterBounce') {
        i -= 1;
        textTarget.textContent = fullText.slice(0, Math.max(0, i));
        typeEl.classList.remove('is-bounce');
        if (i <= 0) {
          if (mode === 'eraseAfterBounce') {
            // Finished post-bounce erase → restart typing
            mode = 'type';
            setTimeout(tick, holdErased);
          } else {
            mode = 'holdErased';
            setTimeout(tick, holdErased);
          }
        } else {
          setTimeout(tick, eraseSpeed);
        }
        return;
      }

      if (mode === 'holdErased') {
        mode = 'bounce';
        i = fullText.length;
        textTarget.textContent = fullText;
        typeEl.classList.remove('is-bounce');
        void typeEl.offsetWidth; // reflow so bounce can replay
        typeEl.classList.add('is-bounce');
        setTimeout(tick, holdBounce);
        return;
      }

      if (mode === 'bounce') {
        mode = 'holdBounce';
        setTimeout(tick, 0);
        return;
      }

      if (mode === 'holdBounce') {
        // After bounce: erase backward, then loop
        typeEl.classList.remove('is-bounce');
        mode = 'eraseAfterBounce';
        setTimeout(tick, 200);
      }
    }

    tick();
  }

  // ===== Account dropdown (Sign In menu) =====
  document.querySelectorAll('[data-account-dropdown]').forEach(wrap => {
    const toggle = wrap.querySelector('[data-account-toggle]');
    const menu = wrap.querySelector('[data-account-menu]');
    if (!toggle || !menu) return;

    function open() {
      menu.hidden = false;
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (menu.hidden) open(); else close();
    });

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  });

  // ===== Custom search category dropdown =====

  document.querySelectorAll('[data-search-cat]').forEach(wrap => {
    const toggle = wrap.querySelector('[data-search-cat-toggle]');
    const menu = wrap.querySelector('[data-search-cat-menu]');
    const label = wrap.querySelector('[data-search-cat-label]');
    const hidden = wrap.querySelector('[data-search-cat-value]');
    if (!toggle || !menu) return;

    function open() {
      menu.hidden = false;
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (menu.hidden) open(); else close();
    });

    menu.querySelectorAll('.search-cat__option').forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.preventDefault();
        const value = opt.getAttribute('data-value') || '';
        const url = opt.getAttribute('data-url') || '';
        const text = opt.querySelector('span:not(.search-cat__option-icon):not(.search-cat__count)');
        if (hidden) {
          hidden.value = value;
          hidden.dataset.url = url;
        }
        if (label) label.textContent = text ? text.textContent.trim() : 'All Categories';
        menu.querySelectorAll('.search-cat__option').forEach(o => o.classList.remove('is-active'));
        opt.classList.add('is-active');
        close();
      });
    });

    const form = wrap.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        const q = form.querySelector('input[name="q"]');
        const query = q ? q.value.trim() : '';
        const catUrl = hidden && hidden.dataset.url ? hidden.dataset.url : '';
        const catVal = hidden ? hidden.value : '';
        // If a specific category is chosen and there is a query, still use site search (type=product)
        // If category chosen with empty query, go to that collection page
        if (catVal && catUrl && !query) {
          e.preventDefault();
          window.location.href = catUrl;
        }
      });
    }

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  });

  // ===== Wishlist (localStorage + cookie, no Shopify app required) =====
  const WL_KEY = 'snipetell_wishlist';
  const SEARCHED_KEY = 'snipetell_has_searched';

  function readCookie(name) {
    try {
      var parts = String(document.cookie || '').split(';');
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i].trim();
        if (p.indexOf(name + '=') === 0) {
          return decodeURIComponent(p.substring(name.length + 1));
        }
      }
    } catch (e) {}
    return null;
  }

  function getWishlist() {
    // Prefer localStorage; fall back to cookie
    try {
      var raw = localStorage.getItem(WL_KEY);
      if (raw) {
        var list = JSON.parse(raw);
        if (Array.isArray(list)) return list;
      }
    } catch (e) {}
    try {
      var c = readCookie(WL_KEY);
      if (c) {
        var list2 = JSON.parse(c);
        if (Array.isArray(list2)) {
          try { localStorage.setItem(WL_KEY, JSON.stringify(list2)); } catch (e2) {}
          return list2;
        }
      }
    } catch (e) {}
    return [];
  }

  function saveWishlist(list) {
    if (!Array.isArray(list)) list = [];
    // Cap size so cookie stays under ~3.5KB
    if (list.length > 80) list = list.slice(0, 80);
    var payload = JSON.stringify(list);
    try { localStorage.setItem(WL_KEY, payload); } catch (e) {}
    try {
      var exp = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
      // Compact cookie value
      document.cookie = WL_KEY + '=' + encodeURIComponent(payload) + '; path=/; expires=' + exp + '; SameSite=Lax';
    } catch (e) {}
    updateWishlistBadge();
    renderWishlistDrawer();
  }

  function isWishlisted(id) {
    id = String(id || '');
    if (!id) return false;
    return getWishlist().some(function (item) { return String(item.id) === id; });
  }

  function toggleWishlist(product) {
    if (!product || !product.id) return false;
    var list = getWishlist();
    var id = String(product.id);
    if (list.some(function (i) { return String(i.id) === id; })) {
      list = list.filter(function (i) { return String(i.id) !== id; });
    } else {
      list.unshift({
        id: id,
        handle: product.handle || '',
        title: product.title || '',
        url: product.url || '',
        image: product.image || '',
        price: product.price || ''
      });
    }
    saveWishlist(list);
    return list.some(function (i) { return String(i.id) === id; });
  }

  function syncWishlistButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('active', isWishlisted(id));
      btn.setAttribute('aria-pressed', isWishlisted(id) ? 'true' : 'false');
    });
  }

  function bindWishlist(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wlBound) return;
      btn.dataset.wlBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('[data-product-card]');
        var id = btn.getAttribute('data-product-id') || (card && card.getAttribute('data-product-id'));
        if (!id) return;
        var product = {
          id: id,
          handle: (card && card.getAttribute('data-product-handle')) || '',
          title: (card && card.getAttribute('data-product-title')) || '',
          url: (card && card.getAttribute('data-product-url')) || '',
          image: (card && card.getAttribute('data-product-image')) || '',
          price: (card && card.getAttribute('data-product-price')) || ''
        };
        var on = toggleWishlist(product);
        btn.classList.toggle('active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        updateFeaturedHeading();
      });
    });
    syncWishlistButtons(root);
  }

  function updateWishlistBadge() {
    var n = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(n);
      el.hidden = n === 0;
    });
  }

  function renderWishlistDrawer() {
    var listEl = document.querySelector('[data-wishlist-list]');
    var emptyEl = document.querySelector('[data-wishlist-empty]');
    if (!listEl) return;
    var list = getWishlist();
    if (!list.length) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    listEl.innerHTML = list.map(function (item) {
      var title = String(item.title || 'Product').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      var url = item.url || '#';
      var img = item.image ? '<img src="' + item.image + '" alt="" width="56" height="56" loading="lazy">' : '';
      var price = item.price ? '<span class="wishlist-drawer__price">' + String(item.price).replace(/</g, '') + '</span>' : '';
      return (
        '<div class="wishlist-drawer__item" data-wl-id="' + String(item.id) + '">' +
          '<a href="' + url + '" class="wishlist-drawer__thumb">' + img + '</a>' +
          '<div class="wishlist-drawer__meta">' +
            '<a href="' + url + '" class="wishlist-drawer__title">' + title + '</a>' + price +
          '</div>' +
          '<button type="button" class="wishlist-drawer__remove" data-wishlist-remove="' + String(item.id) + '" aria-label="Remove">×</button>' +
        '</div>'
      );
    }).join('');
    listEl.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-wishlist-remove');
        var next = getWishlist().filter(function (i) { return String(i.id) !== String(id); });
        saveWishlist(next);
        syncWishlistButtons(document);
      });
    });
  }

  function initWishlistDrawer() {
    var openBtn = document.querySelector('[data-wishlist-open]');
    var drawer = document.querySelector('[data-wishlist-drawer]');
    var closeBtns = document.querySelectorAll('[data-wishlist-close]');
    if (!drawer) return;
    function open() {
      drawer.hidden = false;
      drawer.classList.add('is-open');
      document.body.classList.add('wishlist-open');
      renderWishlistDrawer();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('wishlist-open');
      setTimeout(function () { drawer.hidden = true; }, 200);
    }
    if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    closeBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
    updateWishlistBadge();
    renderWishlistDrawer();
  }

  window.bindWishlist = bindWishlist;
  bindWishlist(document);
  initWishlistDrawer();

  // Track search terms for "You may like" (homepage)
  var SEARCH_TERMS_KEY = 'snipetell_search_terms';
  function readSearchTerms() {
    try {
      var raw = localStorage.getItem(SEARCH_TERMS_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function saveSearchTerm(term) {
    term = String(term || '').trim();
    if (!term) return;
    try {
      localStorage.setItem(SEARCHED_KEY, '1');
      var list = readSearchTerms().filter(function (t) {
        return String(t).toLowerCase() !== term.toLowerCase();
      });
      list.unshift(term);
      localStorage.setItem(SEARCH_TERMS_KEY, JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }
  document.querySelectorAll('form[action*="search"], .search-bar').forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"], input[type="search"]');
      if (input && input.value) saveSearchTerm(input.value);
    });
  });
  if (window.location.pathname.indexOf('/search') !== -1) {
    try {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q');
      if (q) saveSearchTerm(q);
    } catch (e) {}
  }

  // ===== Mobile navigation drawer =====
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.getElementById('mobile-nav');
  const overlay = document.querySelector('[data-nav-overlay]');
  const closeBtn = document.querySelector('[data-nav-close]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('menu-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('menu-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (mobileNav && mobileNav.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeMenu();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('open')) {
      closeMenu();
    }
  });

  if (mobileNav) {
    mobileNav.querySelectorAll('a.nav-item').forEach(link => {
      link.addEventListener('click', () => {
        setTimeout(closeMenu, 150);
      });
    });
  }

  // ===== Hero Slideshow =====
  const slideshow = null; /* disabled: use HERO AUTOSLIDE FIXED */ document.querySelector('[data-hero-slideshow]');
  if (slideshow) {
    const slides = slideshow.querySelectorAll('.hero-slide');
    const dots = slideshow.querySelectorAll('[data-dot-index]');
    const prevBtn = slideshow.querySelector('[data-hero-prev]');
    const nextBtn = slideshow.querySelector('[data-hero-next]');
    const autoplay = slideshow.dataset.autoplay === 'true';
    const interval = parseInt(slideshow.dataset.interval, 10) || 3000;

    let current = 0;
    let timer = null;
    const total = slides.length;

    if (total <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      const dotsWrap = slideshow.querySelector('[data-hero-dots]');
      if (dotsWrap) dotsWrap.style.display = 'none';
    }

    function goTo(index) {
      if (total === 0) return;
      current = (index + total) % total;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', () => { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); startAutoplay(); });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.dotIndex, 10);
        goTo(idx);
        startAutoplay();
      });
    });

    // Pause on hover / focus
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);
    slideshow.addEventListener('focusin', stopAutoplay);
    slideshow.addEventListener('focusout', startAutoplay);

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    slideshow.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    slideshow.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next();
        else prev();
      }
      startAutoplay();
    }, { passive: true });

    // Init
    goTo(0);
    startAutoplay();
  }

  // ===== Product media gallery (with autoslide) =====
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const mediaItems = gallery.querySelectorAll('.product-gallery__media');
    const thumbs = gallery.querySelectorAll('[data-thumb-index]');
    const autoplay = gallery.dataset.autoplay !== 'false';
    const interval = parseInt(gallery.dataset.interval, 10) || 4000;
    let current = 0;
    let timer = null;
    const total = mediaItems.length;

    function showMedia(index) {
      if (total === 0) return;
      current = (index + total) % total;
      mediaItems.forEach((el, i) => {
        const active = i === current;
        el.classList.toggle('is-active', active);
        if (!active) {
          const video = el.querySelector('video');
          if (video) video.pause();
        }
      });
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === current));
    }

    function nextMedia() {
      showMedia(current + 1);
    }

    function startGalleryAutoplay() {
      if (!autoplay || total <= 1) return;
      stopGalleryAutoplay();
      timer = setInterval(nextMedia, interval);
    }

    function stopGalleryAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.dataset.thumbIndex, 10);
        showMedia(idx);
        startGalleryAutoplay();
      });
    });

    gallery.addEventListener('mouseenter', stopGalleryAutoplay);
    gallery.addEventListener('mouseleave', startGalleryAutoplay);
    gallery.addEventListener('focusin', stopGalleryAutoplay);
    gallery.addEventListener('focusout', startGalleryAutoplay);

    // Touch swipe
    let touchStartX = 0;
    gallery.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopGalleryAutoplay();
    }, { passive: true });
    gallery.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) nextMedia();
        else showMedia(current - 1);
      }
      startGalleryAutoplay();
    }, { passive: true });

    showMedia(0);
    startGalleryAutoplay();
  }

  // ===== Product variant selection (basic) =====
  const productJsonEl = document.querySelector('[data-product-json]');
  if (productJsonEl) {
    let productData = null;
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {}

    const form = document.getElementById('product-form') || document.querySelector('form[action*="/cart/add"]');
    const variantInput = document.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-compare-price]');
    const addBtn = document.querySelector('.product-add-to-cart');
    const optionSelects = document.querySelectorAll('[data-option-index]');

    function getSelectedOptions() {
      const opts = [];
      optionSelects.forEach(sel => {
        opts[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
      });
      return opts;
    }

    function findVariant(options) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(v => {
        return v.options.every((opt, i) => opt === options[i]);
      });
    }

    function formatMoney(cents) {
      // Simple fallback; Shopify themes usually have money format helpers
      try {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function updateVariant() {
      if (!productData) return;
      const options = getSelectedOptions();
      const variant = findVariant(options);
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Switch to variant featured media if present
      if (variant.featured_media && gallery) {
        const mediaEl = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (mediaEl) {
          const idx = parseInt(mediaEl.dataset.mediaIndex, 10);
          if (!isNaN(idx)) {
            const mediaItems = gallery.querySelectorAll('.product-gallery__media');
            const thumbs = gallery.querySelectorAll('[data-thumb-index]');
            mediaItems.forEach((el, i) => el.classList.toggle('is-active', i === idx));
            thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
          }
        }
      }
    }

    optionSelects.forEach(sel => {
      sel.addEventListener('change', updateVariant);
    });
  }

  // ===== Collection filter pills =====
  // Cards are queried LIVE on every apply so infinite-scroll products are filtered too.
  (function initCollectionFilters() {
    var root = document.querySelector('[data-collection-filters]');
    if (!root) return;

    var track = root.querySelector('[data-filters-track]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-filter-pill]'));
    var emptyMsg = document.querySelector('[data-filter-empty]');
    var grid = document.querySelector('[data-collection-products], [data-product-grid]');

    function selectedKeys() {
      return pills
        .filter(function (p) { return p.classList.contains('is-on'); })
        .map(function (p) { return p.getAttribute('data-filter-key'); });
    }

    function setPill(pill, on) {
      pill.classList.toggle('is-on', on);
      var input = pill.querySelector('[data-filter-input]');
      if (input) input.checked = on;
    }

    function applyFilters() {
      var keys = selectedKeys();
      var nonAll = pills.filter(function (p) { return p.getAttribute('data-filter-key') !== 'all'; });
      var allPill = pills.find(function (p) { return p.getAttribute('data-filter-key') === 'all'; });

      // If every non-all filter is ON → reset to All only
      if (nonAll.length > 0 && nonAll.every(function (p) { return p.classList.contains('is-on'); })) {
        nonAll.forEach(function (p) { setPill(p, false); });
        if (allPill) setPill(allPill, true);
        keys = ['all'];
      }

      var showAll = keys.indexOf('all') !== -1 || keys.length === 0;
      var visible = 0;

      // ALWAYS read current cards from the DOM (includes infinite-scroll additions)
      var cards = Array.prototype.slice.call(
        (grid || document).querySelectorAll('[data-product-card]')
      );

      cards.forEach(function (card) {
        // Exact token match only — "men" must NEVER match "women"
        var raw = (card.getAttribute('data-filter-keys') || 'all').toLowerCase();
        var fkeys = raw.split(/\s+/).filter(Boolean);
        var fset = {};
        for (var fi = 0; fi < fkeys.length; fi++) fset[fkeys[fi]] = true;

        var show = false;
        if (showAll) {
          show = !!fset['all'];
        } else {
          // OR across selected categories: Kids+Women shows kids OR women, never men
          for (var i = 0; i < keys.length; i++) {
            var k = String(keys[i] || '').toLowerCase();
            if (k && fset[k]) { show = true; break; }
          }
        }
        card.classList.toggle('is-filter-hidden', !show);
        if (show) visible += 1;
      });

      if (emptyMsg) emptyMsg.classList.toggle('is-hidden', visible > 0);
    }

    // Expose so infinite scroll can re-apply after injecting new cards
    window.__snipetellApplyFilters = applyFilters;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        var key = pill.getAttribute('data-filter-key');
        var allPill = pills.find(function (p) { return p.getAttribute('data-filter-key') === 'all'; });
        var isOn = pill.classList.contains('is-on');

        if (key === 'all') {
          // All → clear categories, only All on
          pills.forEach(function (p) { setPill(p, p === pill); });
        } else {
          // Multi-select categories: toggle this one, turn All off
          if (allPill) setPill(allPill, false);
          setPill(pill, !isOn);
          // If nothing left selected, fall back to All
          if (selectedKeys().length === 0 && allPill) setPill(allPill, true);
        }
        applyFilters();
        // Tell infinite scroll to prioritize/load this subcollection fully
        if (typeof window.__snipetellEnsureSub === 'function') {
          window.__snipetellEnsureSub(key === 'all' ? null : key);
        }
      });
    });

    // Horizontal drag/swipe without moving the whole page
    function bindHScroll(el) {
      if (!el || el.getAttribute('data-hscroll-bound')) return;
      el.setAttribute('data-hscroll-bound', '1');
      var down = false, startX = 0, startY = 0, scrollLeft = 0, axis = null;
      el.addEventListener('mousedown', function (e) {
        down = true;
        axis = null;
        el.classList.add('is-dragging');
        startX = e.pageX;
        scrollLeft = el.scrollLeft;
      });
      window.addEventListener('mouseup', function () {
        down = false;
        axis = null;
        el.classList.remove('is-dragging');
      });
      el.addEventListener('mouseleave', function () {
        down = false;
        axis = null;
        el.classList.remove('is-dragging');
      });
      el.addEventListener('mousemove', function (e) {
        if (!down) return;
        e.preventDefault();
        el.scrollLeft = scrollLeft - (e.pageX - startX);
      });
      el.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        startX = e.touches[0].pageX;
        startY = e.touches[0].pageY;
        scrollLeft = el.scrollLeft;
        axis = null;
      }, { passive: true });
      el.addEventListener('touchmove', function (e) {
        if (!e.touches || !e.touches[0]) return;
        var dx = e.touches[0].pageX - startX;
        var dy = e.touches[0].pageY - startY;
        if (axis == null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (axis === 'x') {
          el.scrollLeft = scrollLeft - dx;
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });
    }
    if (track) bindHScroll(track);
    var mob = document.querySelector('[data-mobile-category-bar] .mobile-category-bar__track') ||
              document.querySelector('.mobile-category-bar__track');
    if (mob) bindHScroll(mob);

    applyFilters();
  })();


  // ===== Infinite scroll on collection pages =====
  // v12.0.8 — Hub + child filters (Fashion→Kids/Men/Women/…)
  // One batch per user gesture; filter change loads one batch then waits for scroll.
  (function initInfiniteCollection() {
    var page = document.querySelector('[data-collection-page][data-infinite-scroll="true"]');
    if (!page) return;
    page.setAttribute('data-infinite-version', '12.0.8');

    var grid = page.querySelector('[data-collection-products], [data-product-grid]');
    var sentinel = page.querySelector('[data-infinite-sentinel]');
    var status = page.querySelector('[data-infinite-status]');
    var loadingEl = page.querySelector('[data-infinite-loading]');
    var endEl = page.querySelector('[data-infinite-end]');
    if (!grid) return;

    var handle = (page.getAttribute('data-collection-handle') || '').trim();
    if (!handle) return;
    if (handle === 'best' || handle === 'best-sellers' || handle === 'bestsellers') return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var limit = 250;
    var loading = false;
    var done = false;
    var maxPages = 80;
    // Only true after real user scroll/wheel/touch or filter click (not layout jumps)
    var armed = false;

    var subsEl = page.querySelector('[data-infinite-subs]');
    var subHandles = [];
    var subKeys = [];
    if (subsEl) {
      subHandles = (subsEl.getAttribute('data-sub-handles') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      subKeys = (subsEl.getAttribute('data-sub-keys') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    var already = grid.querySelectorAll('[data-product-card]').length;
    var parentCount = parseInt(page.getAttribute('data-collection-count') || '0', 10) || 0;
    // Hub = parent whose All is the union of child subcollections only
    var isHub = !!(subsEl && subsEl.getAttribute('data-hub-all-subs') === 'true') ||
      (subHandles.length > 0 && parentCount < 80);

    var queue = [];
    var qi = 0;
    var seen = new Set();
    grid.querySelectorAll('[data-product-card]').forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (id) seen.add(String(id));
    });

    function subHandleForKey(key) {
      if (!key) return null;
      for (var i = 0; i < subHandles.length; i++) {
        var sk = (subKeys[i] || '').toLowerCase();
        if (sk === key) return subHandles[i];
      }
      return handle + '-' + key;
    }

    function countCardsForKey(key) {
      var n = 0;
      grid.querySelectorAll('[data-product-card]').forEach(function (el) {
        var raw = (el.getAttribute('data-filter-keys') || '').toLowerCase().split(/\s+/);
        if (raw.indexOf(key) !== -1) n += 1;
      });
      return n;
    }

    function buildDefaultQueue() {
      queue = [];
      qi = 0;
      done = false;
      if (isHub && subHandles.length) {
        // All = combination of every child collection only (not the parent as a standalone catalog)
        for (var sj = 0; sj < subHandles.length; sj++) {
          var sh2 = subHandles[sj];
          if (!sh2 || sh2 === handle) continue;
          var sk2 = subKeys[sj] || sh2.split('-').pop() || 'all';
          var shown = countCardsForKey(String(sk2).toLowerCase());
          var start = shown >= 200 ? 2 : 1;
          queue.push({ handle: sh2, key: sk2, page: start });
        }
      } else {
        // Leaf collection: paginate this collection only
        var startPage = already >= 200 ? 2 : 1;
        queue.push({ handle: handle, key: 'all', page: startPage });
      }
    }

    function focusQueueOnKeys(keys) {
      queue = [];
      qi = 0;
      done = false;
      if (!keys || !keys.length) {
        buildDefaultQueue();
        return;
      }
      for (var i = 0; i < keys.length; i++) {
        var key = String(keys[i] || '').toLowerCase();
        if (!key || key === 'all') continue;
        var sh = subHandleForKey(key);
        if (!sh) continue;
        var shown = countCardsForKey(key);
        // Sample on hub is ~24 — always start at page 1; dups skipped via seen
        var start = shown >= 200 ? 2 : 1;
        queue.push({ handle: sh, key: key, page: start });
      }
      if (!queue.length) buildDefaultQueue();
    }

    buildDefaultQueue();

    function money(cents) {
      var n = Number(cents);
      if (isNaN(n)) return '';
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try { return Shopify.formatMoney(n); } catch (e) {}
      }
      return '$' + (n / 100).toFixed(2);
    }

    function toCents(raw) {
      if (raw == null || raw === '') return null;
      if (typeof raw === 'string' && raw.indexOf('.') !== -1) {
        return Math.round(parseFloat(raw) * 100);
      }
      var n = Number(raw);
      return isNaN(n) ? null : n;
    }

    function productPriceCents(p) {
      var c = toCents(p.price);
      if (c != null) return c;
      if (p.variants && p.variants.length) return toCents(p.variants[0].price);
      return null;
    }

    function productCompareCents(p) {
      var c = toCents(p.compare_at_price);
      if (c != null) return c;
      if (p.variants && p.variants.length) return toCents(p.variants[0].compare_at_price);
      return null;
    }

    function productImageSrc(p) {
      if (p.images && p.images.length) {
        var first = p.images[0];
        if (typeof first === 'string') return first;
        if (first && first.src) return first.src;
      }
      if (p.featured_image) {
        if (typeof p.featured_image === 'string') return p.featured_image;
        if (p.featured_image.src) return p.featured_image.src;
      }
      if (p.variants && p.variants.length && p.variants[0].featured_image) {
        var vf = p.variants[0].featured_image;
        if (typeof vf === 'string') return vf;
        if (vf && vf.src) return vf.src;
      }
      return '';
    }

    function resizeCdn(src, width) {
      if (!src) return '';
      if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('shopify.com') === -1) return src;
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      return src + sep + 'width=' + width;
    }

    function shuffleArray(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = arr[i];
        arr[i] = arr[j];
        arr[j] = t;
      }
      return arr;
    }

    function shuffleGridOnce() {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
      if (cards.length < 2) return;
      shuffleArray(cards);
      for (var i = 0; i < cards.length; i++) grid.appendChild(cards[i]);
    }

    function cardFromProduct(p, filterKey) {
      var id = String(p.id);
      var vid = (p.variants && p.variants[0] && p.variants[0].id) ? String(p.variants[0].id) : '';
      if (seen.has(id)) return '';
      seen.add(id);
      var handleP = p.handle || '';
      var title = String(p.title || '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      var base = root.endsWith('/') ? root : root + '/';
      var url = base + 'products/' + handleP;
      var img = resizeCdn(productImageSrc(p), 400);
      var priceCents = productPriceCents(p);
      var compareCents = productCompareCents(p);
      var price = priceCents != null ? money(priceCents) : '';
      var compare = (compareCents != null && priceCents != null && compareCents > priceCents)
        ? '<span class="compare">' + money(compareCents) + '</span>' : '';
      var fkeys = 'all' + (filterKey && filterKey !== 'all' ? ' ' + filterKey : '');
      return (
        '<a href="' + url + '" class="product-card" data-product-card data-filter-keys="' + fkeys + '" data-product-id="' + id + '"' + (vid ? ' data-variant-id="' + vid + '"' : '') + ' data-product-handle="' + handleP + '" data-product-title="' + title + '" data-product-url="' + url + '" data-product-image="' + (img || '') + '" data-product-price="' + price + '">' +
          '<div class="product-image">' +
            (img ? '<img src="' + img + '" alt="' + title + '" loading="lazy" width="400" height="400">' : '') +
            '<button class="wishlist-btn" type="button" aria-label="Add to wishlist" data-wishlist-toggle data-product-id="' + id + '">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="product-info"><h3 class="product-title">' + title + '</h3><div class="product-price">' + price + ' ' + compare + '</div></div>' +
        '</a>'
      );
    }

    function showEnd() {
      done = true;
      armed = false;
      if (loadingEl) loadingEl.hidden = true;
      if (endEl) {
        endEl.textContent = 'no more content';
        endEl.hidden = false;
      }
      if (status) status.hidden = false;
    }

    function sleep(ms) {
      return new Promise(function (resolve) { setTimeout(resolve, ms); });
    }

    function nearBottom() {
      var scrollPos = window.scrollY + window.innerHeight;
      var docHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      );
      return scrollPos >= docHeight - 650;
    }

    async function fetchPage(srcHandle, pageNum, attempt) {
      attempt = attempt || 0;
      var base = root.endsWith('/') ? root : root + '/';
      var url = base + 'collections/' + encodeURIComponent(srcHandle) +
        '/products.json?limit=' + limit + '&page=' + pageNum;
      var res;
      try {
        res = await fetch(url, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
      } catch (netErr) {
        if (attempt >= 6) throw netErr;
        await sleep(1000 * (attempt + 1));
        return fetchPage(srcHandle, pageNum, attempt + 1);
      }
      if (res.status === 429) {
        if (attempt >= 8) throw new Error('HTTP 429');
        await sleep(3500 * Math.pow(1.35, attempt));
        return fetchPage(srcHandle, pageNum, attempt + 1);
      }
      if (res.status >= 500) {
        if (attempt >= 3) throw new Error('HTTP ' + res.status);
        await sleep(1200 * (attempt + 1));
        return fetchPage(srcHandle, pageNum, attempt + 1);
      }
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }

    // Load at most ONE successful new batch, then disarm
    async function loadMore() {
      if (loading || done || !armed) return;
      if (qi >= queue.length) {
        showEnd();
        return;
      }

      loading = true;
      if (status) status.hidden = false;
      if (loadingEl) loadingEl.hidden = false;
      if (endEl) endEl.hidden = true;

      var skips = 0;
      var maxSkip = 5;

      try {
        while (skips <= maxSkip) {
          if (qi >= queue.length) {
            showEnd();
            return;
          }
          var src = queue[qi];
          if (!src || src.page > maxPages) {
            qi += 1;
            skips += 1;
            continue;
          }

          var data;
          try {
            data = await fetchPage(src.handle, src.page);
          } catch (err) {
            console.warn('Snipetell infinite scroll:', src.handle, err);
            // Skip dead source (500 etc.), try next child — don't kill whole hub
            qi += 1;
            skips += 1;
            await sleep(200);
            continue;
          }

          var products = data.products || [];
          if (!products.length) {
            qi += 1;
            skips += 1;
            continue;
          }

          shuffleArray(products);
          var html = '';
          var added = 0;
          for (var i = 0; i < products.length; i++) {
            var piece = cardFromProduct(products[i], src.key);
            if (piece) {
              html += piece;
              added++;
            }
          }

          src.page += 1;
          if (products.length < limit) qi += 1;

          if (added > 0 && html) {
            grid.insertAdjacentHTML('beforeend', html);
            if (typeof window.bindWishlist === 'function') window.bindWishlist(grid);
            else if (typeof bindWishlist === 'function') bindWishlist(grid);
            if (typeof window.__snipetellApplyFilters === 'function') window.__snipetellApplyFilters();
            // CRITICAL: stop — next batch only after user scrolls again
            armed = false;
            return;
          }

          skips += 1;
          await sleep(40);
        }
      } finally {
        loading = false;
        if (loadingEl) loadingEl.hidden = true;
        armed = false; // never leave armed after a load attempt
      }
    }

    shuffleGridOnce();

    function selectedFilterKeys() {
      var keys = [];
      try {
        page.querySelectorAll('[data-filter-pill].is-on').forEach(function (p) {
          var k = (p.getAttribute('data-filter-key') || '').toLowerCase();
          if (k && k !== 'all') keys.push(k);
        });
      } catch (e) {}
      return keys;
    }

    // Called from filter pills: Fashion → Kids / Men / Women / …
    window.__snipetellEnsureSub = function (key) {
      if (endEl) endEl.hidden = true;
      done = false;

      if (!key) {
        buildDefaultQueue();
        armed = false;
        return;
      }

      var keys = selectedFilterKeys();
      if (keys.indexOf(String(key).toLowerCase()) === -1) keys.push(String(key).toLowerCase());
      focusQueueOnKeys(keys);

      // Load child collection batches until empty or enough cards (fixes Sports showing only samples)
      var tries = 0;
      function fill() {
        if (done || tries > 20) { armed = false; return; }
        if (qi >= queue.length) { armed = false; return; }
        tries += 1;
        armed = true;
        loadMore().then(function () {
          var visible = document.querySelectorAll('[data-product-card]:not(.is-filter-hidden)').length;
          // Keep loading while queue remains and list is still short
          if (!done && qi < queue.length && visible < 60) {
            fill();
          } else {
            armed = false;
          }
        });
      }
      fill();
    };

    function armFromUser() {
      armed = true;
      if (!loading && !done && nearBottom()) loadMore();
    }

    // Real user gestures only (not programmatic scroll from DOM insert)
    window.addEventListener('wheel', function () { armFromUser(); }, { passive: true });
    window.addEventListener('touchmove', function () { armFromUser(); }, { passive: true });
    window.addEventListener('keydown', function (e) {
      var k = e.key || '';
      if (k === 'PageDown' || k === 'ArrowDown' || k === 'End' || k === ' ') armFromUser();
    });

    // Scroll still detects bottom, but only loads if already armed by a gesture
    window.addEventListener('scroll', function () {
      if (!armed || loading || done) return;
      if (nearBottom()) loadMore();
    }, { passive: true });

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!armed || loading || done) return;
          loadMore();
        });
      }, { root: null, rootMargin: '200px 0px', threshold: 0 });
      io.observe(sentinel);
    }
  })();

  // ===== Back to top (centered) =====
  (function initBackToTop() {
    var backTop = document.querySelector('[data-back-to-top]');
    if (!backTop) return;
    function toggleBack() {
      backTop.hidden = window.scrollY <= 400;
    }
    window.addEventListener('scroll', toggleBack, { passive: true });
    toggleBack();
    backTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();


  // Soft-clean product titles on cards (e.g. "370.0Bikini" → "Bikini…")
  (function cleanProductTitles() {
    function clean(el) {
      if (!el || el.getAttribute('data-title-cleaned')) return;
      var t = (el.textContent || '').trim();
      if (!t) return;
      var fixed = t.replace(/^[\d]+(?:\.\d+)?(?=[A-Za-z])/, '').replace(/^\s+/, '');
      if (fixed && fixed !== t) el.textContent = fixed;
      el.setAttribute('data-title-cleaned', '1');
    }
    document.querySelectorAll('.product-title').forEach(clean);
    var grid = document.querySelector('[data-collection-products], [data-product-grid], [data-featured-grid]');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () {
        grid.querySelectorAll('.product-title').forEach(clean);
      }).observe(grid, { childList: true, subtree: true });
    }
  })();

  // ===== First-visit walkthrough — homepage only, short =====
  (function initWalkthrough() {
    var KEY = 'snipetell_walkthrough_done';
    try { if (localStorage.getItem(KEY) === '1') return; } catch (e) {}
    // Only on storefront home — never on collections/search/product
    var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    if (path !== '/' && path !== '') return;

    var steps = [
      { sel: '.logo, [data-logo-wrap]', title: 'Welcome to Snipetell', text: 'Tap the logo anytime to return home.' },
      { sel: '.search-bar, [role="search"]', title: 'Search', text: 'Find products across the catalogue.' }
    ];

    var i = 0;
    var overlay = document.createElement('div');
    overlay.className = 'walkthrough-overlay';
    overlay.innerHTML =
      '<div class="walkthrough-card" role="dialog" aria-modal="true">' +
        '<div class="walkthrough-step"></div>' +
        '<h3 class="walkthrough-title"></h3>' +
        '<p class="walkthrough-text"></p>' +
        '<div class="walkthrough-actions">' +
          '<button type="button" class="walkthrough-skip">Skip</button>' +
          '<button type="button" class="walkthrough-next">Next</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.classList.add('walkthrough-open');

    var titleEl = overlay.querySelector('.walkthrough-title');
    var textEl = overlay.querySelector('.walkthrough-text');
    var stepEl = overlay.querySelector('.walkthrough-step');
    var nextBtn = overlay.querySelector('.walkthrough-next');
    var skipBtn = overlay.querySelector('.walkthrough-skip');

    function finish() {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      overlay.remove();
      document.body.classList.remove('walkthrough-open');
      document.querySelectorAll('.walkthrough-highlight').forEach(function (el) {
        el.classList.remove('walkthrough-highlight');
      });
    }

    function showStep() {
      document.querySelectorAll('.walkthrough-highlight').forEach(function (el) {
        el.classList.remove('walkthrough-highlight');
      });
      if (i >= steps.length) { finish(); return; }
      var step = steps[i];
      var target = document.querySelector(step.sel);
      if (target) target.classList.add('walkthrough-highlight');
      stepEl.textContent = (i + 1) + ' / ' + steps.length;
      titleEl.textContent = step.title;
      textEl.textContent = step.text;
      nextBtn.textContent = i === steps.length - 1 ? 'Got it' : 'Next';
    }

    nextBtn.addEventListener('click', function () { i++; showStep(); });
    skipBtn.addEventListener('click', finish);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) finish();
    });
    setTimeout(showStep, 400);
  })();

});


  // ===== Announcement bar dismiss =====
  (function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    try {
      if (sessionStorage.getItem('snipetell_announce_hide') === '1') {
        bar.hidden = true;
        return;
      }
    } catch (e) {}
    var btn = bar.querySelector('[data-announcement-close]');
    if (btn) {
      btn.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem('snipetell_announce_hide', '1'); } catch (e) {}
      });
    }
  })();

  // ===== Quick Add (Krazia-inspired) =====
  (function initQuickAdd() {
    function updateCartCount(n) {
      var el = document.getElementById('cart-count');
      if (el && typeof n === 'number') el.textContent = String(n);
    }

    async function addVariant(variantId, btn) {
      if (!variantId) return;
      if (btn) {
        btn.classList.add('is-loading');
        btn.disabled = true;
      }
      try {
        var res = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
        if (!res.ok) throw new Error('add failed');
        var cart = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
          credentials: 'same-origin'
        }).then(function (r) { return r.json(); });
        updateCartCount(cart.item_count);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          var prev = btn.textContent;
          btn.textContent = 'Added';
          setTimeout(function () {
            btn.textContent = prev || 'Add';
            btn.classList.remove('is-done');
            btn.disabled = false;
          }, 1200);
        }
      } catch (err) {
        console.warn('Quick add', err);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      }
    }

    function enhanceCard(card) {
      if (!card || card.querySelector('.quick-add-btn')) return;
      var vid = card.getAttribute('data-variant-id');
      if (!vid) return; // only when we know a variant
      var imgWrap = card.querySelector('.product-image');
      if (!imgWrap) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quick-add-btn';
      btn.textContent = 'Add';
      btn.setAttribute('aria-label', 'Quick add to cart');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addVariant(vid, btn);
      });
      imgWrap.appendChild(btn);
    }

    document.querySelectorAll('[data-product-card][data-variant-id]').forEach(enhanceCard);

    // Observe AJAX-injected cards
    var grid = document.querySelector('[data-collection-products], [data-product-grid]');
    if (grid && 'MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches('[data-product-card]')) enhanceCard(n);
            if (n.querySelectorAll) n.querySelectorAll('[data-product-card]').forEach(enhanceCard);
          });
        });
      });
      mo.observe(grid, { childList: true, subtree: true });
    }

    window.__snipetellEnhanceQuickAdd = enhanceCard;
  })();

  // ===== Sticky add to cart on product page =====
  (function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var form = document.getElementById('product-form');
    if (!bar || !form) return;
    var mainBtn = form.querySelector('[type="submit"]');
    function check() {
      if (!mainBtn) {
        bar.hidden = false;
        return;
      }
      var rect = mainBtn.getBoundingClientRect();
      // Show sticky when main button is out of view below or above
      bar.hidden = !(rect.bottom < 0 || rect.top > window.innerHeight);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  })();

  // ===== Recently viewed (localStorage) =====
  (function initRecentlyViewed() {
    var KEY = 'snipetell_recently_viewed';
    var MAX = 10;

    function read() {
      try {
        return JSON.parse(localStorage.getItem(KEY) || '[]');
      } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    }

    // Record current product
    var productJson = document.querySelector('[data-product-json]');
    if (productJson) {
      try {
        var p = JSON.parse(productJson.textContent);
        if (p && p.id) {
          var list = read().filter(function (x) { return String(x.id) !== String(p.id); });
          list.unshift({
            id: p.id,
            handle: p.handle,
            title: p.title,
            url: p.url,
            image: p.image,
            price: p.price
          });
          write(list);
        }
      } catch (e) {}
    }

    var section = document.querySelector('[data-recently-viewed]');
    var grid = document.querySelector('[data-recently-grid]');
    if (!section || !grid) return;
    var items = read();
    // On product page, skip current id
    var currentId = productJson ? (function () {
      try { return String(JSON.parse(productJson.textContent).id); } catch (e) { return ''; }
    })() : '';
    items = items.filter(function (x) { return String(x.id) !== currentId; }).slice(0, 8);
    if (!items.length) return;
    section.hidden = false;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!root.endsWith('/')) root += '/';
    grid.innerHTML = items.map(function (item) {
      var url = item.url || (root + 'products/' + item.handle);
      var img = item.image ? '<img src="' + item.image + '" alt="" loading="lazy" width="400" height="400">' : '';
      return (
        '<a href="' + url + '" class="product-card" data-product-card>' +
          '<div class="product-image">' + img + '</div>' +
          '<div class="product-info"><h3 class="product-title">' + (item.title || '') + '</h3>' +
          '<div class="product-price">' + (item.price || '') + '</div></div></a>'
      );
    }).join('');
  })();


  // ===== Search page infinite scroll (load ALL result pages) =====
  (function initSearchInfinite() {
    var page = document.querySelector('[data-search-page]');
    var grid = document.querySelector('[data-search-grid]');
    if (!page || !grid) return;

    var metaEl = document.querySelector('[data-search-paginate]');
    var meta = {};
    try {
      if (metaEl) meta = JSON.parse(metaEl.textContent || '{}');
    } catch (e) {
      meta = {};
    }

    var terms = meta.terms || page.getAttribute('data-search-terms') || '';
    if (!terms) {
      try {
        terms = new URLSearchParams(window.location.search).get('q') || '';
      } catch (e2) {}
    }
    if (!terms) return;

    var total = parseInt(meta.total || page.getAttribute('data-search-count') || '0', 10) || 0;
    var pageSize = parseInt(meta.page_size || '24', 10) || 24;
    var nextPage = (parseInt(meta.page || '1', 10) || 1) + 1;
    // Prefer Liquid paginate.pages; also allow total/pageSize when Shopify under-reports pages
    var maxPage = Math.max(
      parseInt(meta.pages || '1', 10) || 1,
      total > 0 ? Math.ceil(total / pageSize) : 1
    );

    var loading = false;
    var done = false;
    var loadingEl = document.querySelector('[data-search-loading]');
    var endEl = document.querySelector('[data-search-end]');
    var sentinel = document.querySelector('[data-search-sentinel]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';

    function nearBottom() {
      var doc = document.documentElement;
      return window.scrollY + window.innerHeight >= Math.max(doc.scrollHeight, document.body.scrollHeight) - 800;
    }

    function showEnd() {
      done = true;
      if (endEl) {
        endEl.hidden = false;
        endEl.textContent = 'no more content';
      }
      if (loadingEl) loadingEl.hidden = true;
    }

    async function loadMore() {
      if (loading || done) return;
      if (nextPage > maxPage) {
        showEnd();
        return;
      }
      loading = true;
      if (loadingEl) loadingEl.hidden = false;
      try {
        var url =
          root +
          'search?q=' +
          encodeURIComponent(terms) +
          '&type=product&page=' +
          nextPage +
          '&section_id=main-search';
        // section_id may 404 on some themes — fallback without it
        var res = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!res.ok) {
          url = root + 'search?q=' + encodeURIComponent(terms) + '&type=product&page=' + nextPage;
          res = await fetch(url, { credentials: 'same-origin' });
        }
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll(
          '[data-search-grid] .product-card, .search-page .product-card, #SearchResults .product-card'
        );
        if (!cards.length) {
          showEnd();
          return;
        }
        var frag = document.createDocumentFragment();
        var seen = {};
        grid.querySelectorAll('[data-product-id]').forEach(function (el) {
          seen[el.getAttribute('data-product-id')] = true;
        });
        var added = 0;
        cards.forEach(function (card) {
          var id = card.getAttribute('data-product-id') || card.getAttribute('href');
          if (id && seen[id]) return;
          if (id) seen[id] = true;
          frag.appendChild(document.importNode(card, true));
          added++;
        });
        if (added) grid.appendChild(frag);
        if (typeof window.bindWishlist === 'function') window.bindWishlist(grid);
        nextPage += 1;
        if (nextPage > maxPage || added === 0) showEnd();
      } catch (err) {
        console.warn('Search load more', err);
      } finally {
        loading = false;
        if (loadingEl && !done) loadingEl.hidden = true;
      }
    }

    // Always attach scroll + observer (even if maxPage is 1 but total > visible)
    var visible = grid.querySelectorAll('.product-card').length;
    if (total > visible || maxPage > 1) {
      window.addEventListener(
        'scroll',
        function () {
          if (!loading && !done && nearBottom()) loadMore();
        },
        { passive: true }
      );
      if (sentinel && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !loading && !done) loadMore();
            });
          },
          { rootMargin: '400px 0px' }
        );
        io.observe(sentinel);
      }
      // Kick once if page is short
      setTimeout(function () {
        if (!done && nearBottom()) loadMore();
      }, 400);
    } else {
      showEnd();
    }
  })();

  // ===== You may like (homepage) — only after user has searched =====
  (function initYouMayLike() {
    var section = document.querySelector('[data-you-may-like]');
    var grid = document.querySelector('[data-you-may-like-grid]');
    if (!section || !grid) return;

    var terms = [];
    try {
      var raw = localStorage.getItem('snipetell_search_terms');
      terms = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(terms)) terms = [];
    } catch (e) { terms = []; }

    if (!terms.length) {
      section.hidden = true;
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!root.endsWith('/')) root += '/';

    function shuffle(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
      }
      return arr;
    }

    function cardHtml(p) {
      var url = p.url || (root + 'products/' + (p.handle || ''));
      if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') url = root + url.replace(/^\//, '');
      var img = '';
      if (p.image) img = p.image;
      else if (p.featured_image) img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
      else if (p.featured_media && p.featured_media.preview_image) img = p.featured_media.preview_image.src || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var title = (p.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      var price = p.price != null ? (typeof p.price === 'number' ? ('$' + (p.price / 100).toFixed(2)) : String(p.price)) : '';
      if (p.price_min != null && !price) price = '$' + (Number(p.price_min) / 100).toFixed(2);
      return (
        '<a href="' + url + '" class="product-card" data-product-card>' +
          '<div class="product-image">' +
            (img ? '<img src="' + img + '" alt="' + title + '" loading="lazy" width="400" height="400">' : '') +
          '</div>' +
          '<div class="product-info"><h3 class="product-title">' + title + '</h3>' +
          '<div class="product-price">' + price + '</div></div></a>'
      );
    }

    async function fetchSuggest(term) {
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
      try {
        var res = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
        if (!res.ok) return [];
        var data = await res.json();
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        return products;
      } catch (e) {
        return [];
      }
    }

    (async function run() {
      var seen = {};
      var pool = [];
      // Use up to 3 recent search terms
      var useTerms = terms.slice(0, 3);
      for (var i = 0; i < useTerms.length; i++) {
        var prods = await fetchSuggest(useTerms[i]);
        for (var j = 0; j < prods.length; j++) {
          var p = prods[j];
          var id = String(p.id || p.handle || j);
          if (seen[id]) continue;
          seen[id] = true;
          pool.push(p);
        }
      }
      if (!pool.length) {
        section.hidden = true;
        return;
      }
      shuffle(pool);
      var pick = pool.slice(0, 6);
      grid.innerHTML = pick.map(cardHtml).join('');
      section.hidden = false;
      if (typeof window.bindWishlist === 'function') window.bindWishlist(grid);
    })();
  })();


/* Hero: respect data-device desktop/mobile */
(function () {
  function device() {
    return window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop';
  }
  function visibleSlides(root) {
    return Array.prototype.filter.call(root.querySelectorAll('.hero-slide'), function (s) {
      var d = (s.getAttribute('data-device') || 'both').toLowerCase();
      return d === 'both' || d === device();
    });
  }
  function rebuildDots(root, slides) {
    var dots = root.querySelector('[data-hero-dots]');
    if (!dots) return;
    dots.innerHTML = '';
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hero-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('data-dot-index', String(i));
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dots.appendChild(b);
    });
  }
  function activate(slides, index) {
    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
    });
    var root = slides[0] && slides[0].closest('[data-hero-slideshow]');
    if (!root) return;
    root.querySelectorAll('[data-hero-dots] .hero-dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
    });
  }
  function enhanceHero(root) {
    if (!root || root.__deviceHero || root.__heroFixed) return;
    root.__deviceHero = true;
    var slides = visibleSlides(root);
    if (!slides.length) return;
    root.querySelectorAll('.hero-slide').forEach(function (s) { s.classList.remove('is-active'); });
    slides[0].classList.add('is-active');
    rebuildDots(root, slides);
    var idx = 0;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var interval = parseInt(root.getAttribute('data-interval') || '3000', 10) || 3000;
    var timer = null;
    function go(n) {
      slides = visibleSlides(root);
      if (!slides.length) return;
      idx = (n + slides.length) % slides.length;
      activate(slides, idx);
    }
    function start() {
      stop();
      if (!autoplay) return;
      timer = setInterval(function () { go(idx + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-hero-next]')) { go(idx + 1); start(); }
      if (e.target.closest('[data-hero-prev]')) { go(idx - 1); start(); }
      var dot = e.target.closest('[data-dot-index]');
      if (dot) { go(parseInt(dot.getAttribute('data-dot-index'), 10) || 0); start(); }
    });
    window.addEventListener('resize', function () {
      slides = visibleSlides(root);
      rebuildDots(root, slides);
      idx = 0;
      activate(slides, 0);
    });
    start();
  }
  function boot() {
    document.querySelectorAll('[data-hero-slideshow], [data-hero]').forEach(enhanceHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* offer timer + popup backup */
(function(){
  function pad(n){return(n<10?'0':'')+n}
  function runTimer(){
    var bar=document.getElementById('offer-bar');
    var el=document.getElementById('offer-timer');
    if(!bar||!el)return;
    var hours=parseInt(bar.getAttribute('data-offer-hours')||'24',10)||24;
    var key='snipetell_offer_ends_v3';
    var ends=parseInt(localStorage.getItem(key)||'0',10);
    var now=Date.now();
    if(!ends||ends<now){ends=now+hours*3600*1000;try{localStorage.setItem(key,String(ends))}catch(e){}}
    function tick(){
      var left=Math.max(0,ends-Date.now());
      var s=Math.floor(left/1000);
      el.textContent=pad(Math.floor(s/3600))+':'+pad(Math.floor((s%3600)/60))+':'+pad(s%60);
      if(left<=0){ends=Date.now()+hours*3600*1000;try{localStorage.setItem(key,String(ends))}catch(e){}}
    }
    tick();setInterval(tick,1000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',runTimer);
  else runTimer();
})();


/* product card hover gallery arrows */
(function(){
  function bindCard(card){
    var json=card.querySelector('[data-card-images]');
    if(!json) return;
    var imgs=[];
    try{imgs=JSON.parse(json.textContent||'[]')}catch(e){return}
    if(imgs.length<2) return;
    var idx=0;
    var primary=card.querySelector('.product-card__img--primary');
    var secondary=card.querySelector('.product-card__img--secondary');
    function show(i){
      idx=(i+imgs.length)%imgs.length;
      if(primary) primary.src=imgs[idx];
      if(secondary) secondary.src=imgs[(idx+1)%imgs.length];
      if(secondary) secondary.style.opacity='0';
    }
    var prev=card.querySelector('[data-card-prev]');
    var next=card.querySelector('[data-card-next]');
    if(prev) prev.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();show(idx-1)});
    if(next) next.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();show(idx+1)});
  }
  function boot(){document.querySelectorAll('[data-product-card]').forEach(bindCard)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();

(function(){
  function sync(root){
    root.querySelectorAll('.product-option__chip').forEach(function(lab){
      var inp=lab.querySelector('input');
      if(inp&&inp.checked) lab.classList.add('is-selected'); else lab.classList.remove('is-selected');
    });
  }
  function boot(){
    document.querySelectorAll('[data-product-page]').forEach(function(root){
      sync(root);
      root.addEventListener('change', function(){ sync(root); });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

(function(){
  document.addEventListener('click', function(e){
    var minus=e.target.closest('[data-qty-minus]');
    var plus=e.target.closest('[data-qty-plus]');
    if(!minus&&!plus) return;
    var wrap=(minus||plus).closest('[data-qty-wrap]');
    if(!wrap) return;
    var input=wrap.querySelector('[data-qty-input],input.qty');
    if(!input) return;
    // Cart page / drawer line items: owned by cart AJAX — do nothing here
    if(input.getAttribute('data-line-key') || input.closest('.cart-line') || input.closest('form.cart-form') || input.closest('form#cart-form') || input.closest('[data-cart-page]') || input.closest('.cart-page')) {
      return;
    }
    var min=parseInt(input.getAttribute('min')||'0',10);
    var n=parseInt(input.value,10)||min;
    if(minus) n=Math.max(min,n-1);
    if(plus) n=n+1;
    input.value=n;
  });
})();
